import type { DesignScores } from '@/types/design'
import type { Lang } from '@/hooks/useLang'

interface ScoreRadarProps {
  scores: DesignScores
  lang: Lang
}

const LABELS = {
  fr: { feasibility: 'Faisabilité', complexity: 'Complexité', market: 'Marché', innovation: 'Innovation' },
  en: { feasibility: 'Feasibility', complexity: 'Complexity', market: 'Market', innovation: 'Innovation' },
}

const COLORS = {
  feasibility: '#00f0ff',
  complexity: '#ebb2ff',
  market: '#dbfcff',
  innovation: '#f8f4ff',
}

export default function ScoreRadar({ scores, lang }: ScoreRadarProps) {
  const t = LABELS[lang]
  const rows = [
    { key: 'feasibility', label: t.feasibility, value: scores.feasibility, color: COLORS.feasibility },
    { key: 'complexity', label: t.complexity, value: scores.complexity, color: COLORS.complexity },
    { key: 'market', label: t.market, value: scores.market_demand, color: COLORS.market },
    { key: 'innovation', label: t.innovation, value: scores.innovation, color: COLORS.innovation },
  ]

  return (
    <div className="space-y-4">
      {rows.map((row) => (
        <div key={row.key}>
          <div className="flex justify-between items-center mb-1.5">
            <span className="text-xs font-label text-on-surface-variant">{row.label}</span>
            <span className="font-headline text-sm font-bold" style={{ color: row.color }}>{row.value}%</span>
          </div>
          <div className="h-1.5 w-full bg-surface-container-highest rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{ width: `${row.value}%`, backgroundColor: row.color, opacity: 0.85 }}
            />
          </div>
        </div>
      ))}
    </div>
  )
}
